import React from 'react';
import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message as antdMessage, notification } from 'antd';

// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean; // 后端返回的 success 字段
  code: string; // 统一用字符串表示错误码，跟后端对应
  message: string; // 错误提示或者成功消息
  data?: any;
  showType?: ErrorShowType; // 可选，决定如何展示错误
}

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      const { success, data, code, message, showType } = res as unknown as ResponseStructure;
      if (!success) {
        const error: any = new Error(message);
        error.name = 'BizError';
        error.info = { code, message, showType, data };
        throw error;
      }
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      // 我们的 errorThrower 抛出的错误。
      if (error.name === 'BizError') {
        const errorInfo: ResponseStructure | undefined = error.info;
        if (errorInfo) {
          const { message: msg, code } = errorInfo;
          const formattedMessage = <div style={{ whiteSpace: 'pre-line' }}>{msg}</div>;

          switch (errorInfo.showType) {
            case ErrorShowType.SILENT:
              // do nothing
              break;
            case ErrorShowType.WARN_MESSAGE:
              antdMessage.warning(formattedMessage);
              break;
            case ErrorShowType.ERROR_MESSAGE:
              antdMessage.error(formattedMessage);
              break;
            case ErrorShowType.NOTIFICATION:
              notification.open({
                description: formattedMessage,
                message: code,
              });
              break;
            case ErrorShowType.REDIRECT:
              // TODO: redirect
              // 这个地方直接迁移是不是不太好？
              break;
            default:
              antdMessage.error(formattedMessage);
          }
        }
      } else if (error.response) {
        // Axios 的错误
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        const status = error.response.status;
        let errorMsg = `Response status: ${status}`;
        if (error.response.data && error.response.data.message) {
          const formattedMessage = (
            <div style={{ whiteSpace: 'pre-line' }}>{error.response.data.message}</div>
          );
          antdMessage.error({
            content: <div style={{ textAlign: 'left' }}>{formattedMessage}</div>,
            duration: 3,
          });
        } else {
          // 没有详细消息，展示状态码文本
          antdMessage.error('通信エラーが発生しました。管理者に連絡してください。', 3);
          console.log(errorMsg);
        }
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        // \`error.request\` 在浏览器中是 XMLHttpRequest 的实例，
        // 而在node.js中是 http.ClientRequest 的实例
        // antdMessage.error('None response! Please retry.');
        antdMessage.error('通信エラーが発生しました。管理者に連絡してください。', 3);
      } else {
        // 发送请求时出了点问题
        // antdMessage.error('Request error, please retry.');
        antdMessage.error('通信エラーが発生しました。管理者に連絡してください。', 3);
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    (url: string, options: RequestOptions) => {
      //  自动携带 Cookie
      return {
        url,
        options: {
          ...options,
          credentials: 'include',
        },
      };
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const { data } = response as unknown as ResponseStructure;

      if (data?.success === false) {
        // antdMessage.error('请求失败！');
      }
      return response;
    },
  ],
};
